import React, { Component } from 'react';
import TextMessage from './TextMessage';
import EmojiMessage from './EmojiMessage';
import FileMessage from './FileMessage';
import ImageMessage from './ImageMessage';
import moment from 'moment'
import Avatar from 'react-avatar';
// import { UserInput } from '../UserInput';
import {Row,Col,Modal, ModalBody,ModalHeader} from "reactstrap";
import Linkify from 'react-linkify';
// import { getCurrentUser } from './../../../services/AuthService'
import { EditorState } from 'draft-js';
// import Editor , { createEditorStateWithText,createFromText,composeDecorators } from 'draft-js-plugins-editor';
// import draftToHtml from 'draftjs-to-html';
// import {  Input } from 'reactstrap'
// import ReplyMessage from './ReplyMessage';



class Message extends Component {
  constructor() {
    super();
    this.handleMouseHover = this.handleMouseHover.bind(this);
    this.showImagePopup = this.showImagePopup.bind(this);
    this.state = {
      profile: '',
      contenttype: true,
      isHovering: false,
      avatarcolor: [
       'violet', 'coral', '#851fc4','sandybrown','pink','green','#4d95db','#aba9ad','#f44336','#9c27b0',
       '#673ab7','#00bcd4'
      ],
      open:false,
      setOpen:false,
      editorState: EditorState.createEmpty(),


    };
    this._renderMessageOfType = this._renderMessageOfType.bind(this);

  }
  handleMouseHover() {
    this.setState(this.toggleHoverState);
  }

  toggleHoverState(state) {
    // console.log('state',state)
    return {
      isHovering: !state.isHovering,
    };
  }
  showImagePopup (){
    if (this.state.open) {
      this.setState({open: false})
    } else {
      this.setState({open: true})
    }
  }
  componentDidMount() {
  var background = this.state.avatarcolor[Math.floor(Math.random() * this.state.avatarcolor.length)];
  this.state.selectedColor = background;
  this.setState({
   // selectedColor:background,
    profile: JSON.parse(localStorage.getItem('UserProfile'))
  });
  }
    _renderMessageOfType(type,authorType) {
    // console.log('media',this.props.message)
    switch (type) {
      case 'text':
        return <TextMessage {...this.props.message} authorType={authorType}/>;
      case 'emoji':
        return <EmojiMessage {...this.props.message} authorType={authorType}/>;
      case 'file':
        return <FileMessage {...this.props.message} authorType={authorType}/>;
        case 'media':
        return <ImageMessage {...this.props.message} authorType={authorType} />;
      default:
        // console.error(`Attempting to load message with unsupported file type '${type}'`);
        return <TextMessage {...this.props.message} />;
    }
  }

  replyparticularChat = (message) =>{
    // this.state.replymsg = "true"
    // this.state.chatmasterid = message.chatMasterId;
    // this.state.type = message.messageType;
    this.setState({
      replymsg: "true",
      chatmasterid:message.chatMasterId,
      type:message.messageType
    })
  }
 
  render() {
    let userId = localStorage.getItem("Uid");
    let authorType = 'sent'
    if (userId !== this.props.message.userId) {
      authorType = 'received';
    //  this.setState({contenttype:false})
      this.state.contenttype = false;
    }
    if (this.props.message.userId === undefined) {
      authorType = 'sent';
    }
   // console.log('rendermsg', JSON.stringify(this.props.message));
    let contentClassList = [
      'sc-message--content', authorType
    ];
    return (
      <Col lg="12" md="12" className="chatmsghover" onMouseEnter={this.handleMouseHover} onMouseLeave={this.handleMouseHover}>
       <Row className="msglistrow">
      {/* <Row className="msglistrow"  style={{marginTop:20}}  onMouseEnter={this.handleMouseHover}  onMouseLeave={this.handleMouseHover}> */}
       <Col xs="12">
        <div  id="contenttype" className="sc-message">
              <div className={authorType === "received" ? contentClassList.join(' ')+" d-flex justify-content-start" : contentClassList.join(' ')+" d-flex justify-content-end"}>
                  <div className={authorType === "sent" ? "sc-message--avatar order-1" : "sc-message--avatar"}>
                    {this.props.message.photoURL == null ? (
                      <Avatar round={true} color={authorType === "received" ? this.state.selectedColor : "#f96332"} name={this.props.message.firstName === null || undefined ? this.state.profile.firstName + " " + this.state.profile.lastName : this.props.message.firstName + " " + this.props.message.lastName} size="35" />
                    ) : <img src={this.props.message.photoURL} className="rounded" alt="avatar"
                      />}
                  </div>
                  <div style={{marginRight:20}} className={authorType === "received" ? "receivedChatBox w-auto rounded leftChat" : "sentChatBox w-auto rounded rightChat"}>
                      <Row className="align-items-center">
                            <div className={authorType === "received" ? "col text-primary" : "col text-primary"} >
                            {/*moment.utc(this.props.message.createdDate).local().format('MMM DD,HH:mm a')*/}
                            <b style={{ fontSize: '13px'}}>{this.props.message.firstName === null || undefined ? this.state.profile.firstName + " " + this.state.profile.lastName : this.props.message.firstName + " " + this.props.message.lastName}</b>  &nbsp; 
                            <span className={authorType === "received" ? "receiveddatestyle pt-1" : "sentdatestyle pt-1"}>{this.props.message.createdDate != null ? moment.parseZone(this.props.message.createdDate).local().format("MMMM DD, YYYY hh:mm:ss a")  : ""}
                              <i className={authorType === "received" ? "" : "fas fa-check fa-1x ml-3"}></i>
                            </span>

                                {/* <b style={{ fontSize: '13px' }}>{this.props.message.firstName + " " + this.props.message.lastName}</b>  &nbsp; <span style={{ fontSize: '10px', color: '#a1a0a4',float:"right" }}>{this.props.message.createdDate != null ? moment.utc(this.props.message.createdDate).local().format('MMM DD,HH:mm a') : ""}</span> */}
                            </div>              
                        </Row>
                  <div>
                  {this.props.message.mediaBase64Content!=null?<img className="mediaDisplay" onClick={this.showImagePopup} alt="avatar" src={`data:image/jpeg;base64,${this.props.message.mediaBase64Content}`}/>:""}

                 <Linkify>
                        {this._renderMessageOfType(this.props.message.messageType,authorType)}
                  </Linkify>
                  <Modal
                          centered
                          isOpen={this.state.open}
                          toogle={this.showImagePopup}
                          backdrop="static"
                        >
                        <ModalHeader toggle={this.showImagePopup}>&nbsp;</ModalHeader>
                          <ModalBody>
                              <Row>
                               <Col>
                               <br></br>
                                 <img alt="avatar" src={`data:image/jpeg;base64,${this.props.message.mediaBase64Content}`}/>
                               </Col>
                             </Row>
                          </ModalBody>
                        </Modal>
                </div>
       {/* { this.state.replymsg &&
                  <div className="chatreply">
                                 <ReplyMessage {...this.props.message}></ReplyMessage>
                  </div>
        } */}
        </div>
        </div>
      </div>
      </Col>
       {/* <Col xs="2" className="float-right">
      {
          this.state.isHovering &&
          <div style={{position:"absolute",marginTop:-10,zIndex:9999}}>
           <Card style={{border:"1px solid #d3d3d3",borderRadius:10, padding:5}}>
            <span style={{cursor:"pointer"}} title="Reply" onClick={(e)=>this.replyparticularChat(this.props.message)}> 
                <i className="fa fa-reply text-red mr-2" style={{fontSize:'13px'}}/>
           </span>
           <span style={{cursor:"pointer"}} title="Edit"> 
                <i className="fas fa-edit text-red mr-2" style={{fontSize:'13px'}}/>
           </span>
           <span style={{cursor:"pointer"}} title="Delete"> 
            <i className="fas fa-trash-alt text-red mr-2" style={{fontSize:'13px'}}/>
           </span>
           </Card>                
              <UncontrolledDropdown>  
                            <DropdownToggle
                            tag="span"
                                onClick={e => e.preventDefault()}
                                style={{color: '#007bff',cursor:'pointer'}}
                            >
                            <br></br>
                            <i className="fas fa-ellipsis-v" /> 
                            </DropdownToggle>
                            <DropdownMenu 
                            right
                              className="dropdown-menu-arrow chatsettings"
                            >
                            <DropdownItem
                                href="" 
                                onClick={(e)=>this.replyparticularChat(this.props.message)}>
                              <span> 
                              <i className="fas fa-edit text-red mr-3" />Reply
                              </span>
                              </DropdownItem> 
                             <DropdownItem
                                href="" >
                              <span> 
                              <i className="fas fa-edit text-red mr-3" />Edit
                              </span>
                              </DropdownItem>     
                              <DropdownItem
                                href="" >
                              <span> 
        <i className="fas fa-trash-alt text-red mr-3" />Delete
        </span>
                              </DropdownItem>                          
                            </DropdownMenu>
            </UncontrolledDropdown> 
          </div>
            } 
      </Col>
       */}
      </Row>
      </Col>
      
      );
  }
}
// Message.propTypes = {
//   replymessage: PropTypes.func.isRequired,
// };
export default Message;
